document.addEventListener("DOMContentLoaded", () => {
  const config = {
    localStorageKey: `${location.hostname}-search_history`,
    maxEntries: 12,
    selectors: {
      // Dawn標準・えびすツール独自・その他の検索フォームを網羅
      form: 'form.search, form.yebisu-search-form, form[action^="/search"]',
      // hidden の name="q"（絞り込みフォーム等）は除外する
      input: '.search__input, .yebisu-search-input, input[name="q"]:not([type="hidden"])',
      button: ".history-search-button",
      results: "[data-search-results]",
    },
  };

  // タッチ端末での取りこぼしを防ぐため pointerdown を使う
  const POINTER_DOWN = window.PointerEvent ? "pointerdown" : "mousedown";
  let resultsSaved = false;

  bindForms();
  saveFromResultsPage();

  // 後から差し込まれる検索フォーム（ドロワー内・アプリ・セクション再描画）にも対応
  const observer = new MutationObserver(() => bindForms());
  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener("shopify:section:load", bindForms);

  /* ============================================================
     フォームへの結線
     ============================================================ */
  function bindForms() {
    document.querySelectorAll(config.selectors.form).forEach((form) => {
      if (form.dataset.searchHistoryBound) return; // 二重バインド防止
      const input = form.querySelector(config.selectors.input);
      if (!input) return; // 入力欄が無いフォームは対象外（例外で全体が止まるのを防ぐ）

      form.dataset.searchHistoryBound = "true";

      const container = document.createElement("div");
      container.className = "history-list-container";
      form.appendChild(container);

      // 送信時に履歴を保存（preventDefaultせず通常送信に任せる）
      form.addEventListener("submit", () => {
        const word = input.value.trim();
        if (word) pushHistory({ word });
        toggle(container, false);
      });

      // 開く：フォーカス時＋既にフォーカス済みの再タップ時
      input.addEventListener("focus", () => toggle(container, true));
      input.addEventListener(POINTER_DOWN, () => toggle(container, true));

      // ドロップダウン内を押しても入力欄のフォーカスを外さない（＝閉じない）
      container.addEventListener(POINTER_DOWN, (event) => event.preventDefault());

      // 履歴クリック → 入力欄に反映して送信
      container.addEventListener("click", (event) => {
        const button = event.target.closest(config.selectors.button);
        if (!button || !button.dataset.word) return;
        input.value = button.dataset.word;
        if (typeof form.requestSubmit === "function") {
          form.requestSubmit(); // submitイベントを発火させて履歴も更新
        } else {
          pushHistory({ word: button.dataset.word });
          form.submit();
        }
      });

      // 外側タップで閉じる（blurに頼らない）
      document.addEventListener(POINTER_DOWN, (event) => {
        if (!form.contains(event.target)) toggle(container, false);
      });

      // Escapeで閉じる
      input.addEventListener("keydown", (event) => {
        if (event.key === "Escape") toggle(container, false);
      });
    });
  }

  /* ============================================================
     表示
     ============================================================ */
  function toggle(container, isOpen) {
    container.classList.toggle("is-open", isOpen);
    if (isOpen) render(container);
  }

  function render(container) {
    const history = getHistory().slice().reverse();

    if (!history.length) {
      container.innerHTML = '<p class="no-history">履歴はありません</p>';
      return;
    }

    const items = history
      .map(({ word, date, count }) => {
        const safeWord = escapeHtml(word);
        const hits = Number.isFinite(count) ? `（${count}件）` : "";
        return `<li>
          <button type="button" class="history-search-button" data-word="${safeWord}">
            <span>${safeWord}${hits}</span>
            <time datetime="${escapeHtml(date)}">${formatElapsedTime(date)}</time>
          </button>
        </li>`;
      })
      .join("");

    container.innerHTML = `<ul class="history-list">${items}</ul>`;
  }

  /* ============================================================
     検索結果ページでヒット件数付きの履歴を保存
     ============================================================ */
  function saveFromResultsPage() {
    if (resultsSaved) return;
    const results = document.querySelector(config.selectors.results);
    if (!results) return;

    const count = parseInt(results.dataset.searchResultsCount, 10);
    const word = (results.dataset.searchResultsWord || "").trim();
    if (!word || isNaN(count)) return;

    pushHistory({ word, count });
    resultsSaved = true;
  }

  /* ============================================================
     localStorage
     ============================================================ */
  function pushHistory({ word, count }) {
    const entry = { word, date: new Date().toISOString() };
    if (Number.isFinite(count)) entry.count = count;

    const updated = [
      ...getHistory().filter((item) => item && item.word !== word),
      entry,
    ].slice(-config.maxEntries);

    try {
      localStorage.setItem(config.localStorageKey, JSON.stringify(updated));
    } catch (e) {
      /* プライベートモード等で書き込めない場合は何もしない */
    }
  }

  function getHistory() {
    try {
      const data = JSON.parse(localStorage.getItem(config.localStorageKey));
      return Array.isArray(data) ? data.filter((item) => item && item.word) : [];
    } catch (e) {
      return [];
    }
  }

  /* ============================================================
     ユーティリティ
     ============================================================ */
  function escapeHtml(value) {
    return String(value == null ? "" : value).replace(
      /[&<>"']/g,
      (char) =>
        ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[char])
    );
  }

  function formatElapsedTime(dateString) {
    const saved = new Date(dateString);
    if (isNaN(saved)) return "";

    const diff = Math.floor((Date.now() - saved.getTime()) / 1000);
    if (diff < 60) return "たった今";
    const minutes = Math.floor(diff / 60);
    if (minutes < 60) return `${minutes}分前`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours}時間前`;
    const days = Math.floor(hours / 24);
    if (days < 30) return `${days}日前`;
    const months = Math.floor(days / 30);
    if (months < 12) return `${months}ヶ月前`;
    return `${Math.floor(months / 12)}年前`;
  }
});